import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface SalesButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'lg' | 'xl';
  fullWidth?: boolean;
  showIcon?: boolean;
}
export function SalesButton({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  showIcon = true,
  className = '',
  ...props
}: SalesButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 rounded-full shadow-lg active:scale-95';
  const variants = {
    primary: 'bg-[#10B981] text-white hover:bg-[#059669] shadow-[0_4px_20px_0_rgba(16,185,129,0.4)] hover:shadow-[0_6px_30px_rgba(16,185,129,0.5)]',
    secondary: 'bg-[#1B5E20] text-white hover:bg-[#14532D] shadow-xl',
    outline: 'border-2 border-[#10B981] text-[#10B981] hover:bg-[#10B981] hover:text-white'
  };
  const sizes = {
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-310">
      {children}
      {showIcon && <ArrowRight className="ml-2 w-5 h-5" data-id="element-311" />}
    </motion.button>;
}